import ReviewTeam from './ReviewTeam';
export default ReviewTeam;
